import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { utility } from './constant';
import { Utils } from "../app/util/utility";
import {BnSearchResponse} from "../app/company-registration/company-secretary/bnSearchResponse";


@Injectable({
  providedIn: 'root',
})
export class ApiService {
  SERVER_URL = environment.serverUrl;
  AUTH_URL = environment.authUrl;

  BnSearchUrl = environment.bnSearchUrl

  suppressAlertError: boolean = false;

  constructor(public httpClient: HttpClient) {
  }

  public get(actionUrl: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;

    return this.httpClient.get<any>(url, options || {}).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  public post(actionUrl: any, request: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;

    return this.httpClient.post<any>(url, request, options || {}).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        return this.handleError(error);
      })
    );
  }

  // public authPost(actionUrl: any, request: any, options?: any): Observable<any> {
  //   const url = this.AUTH_URL + actionUrl;
  //   if (options) {
  //     return this.httpClient.post<any>(url, request, options).pipe(
  //       map(response => {
  //         return response;
  //       }),
  //       catchError(error => {
  //         // return this.getServerErrorMessage(error)
  //         return this.handleError(error);
  //       })
  //     );
  //   } else {
  //     return this.httpClient.post<any>(url, request).pipe(
  //       map(response => {
  //         return response;
  //       }),
  //       catchError(error => {
  //         return this.handleError(error);
  //       })
  //     );
  //   }
  // }


  public get_(actionUrl: any): Observable<any> {
    return this.get(actionUrl, {headers: utility.allHeader});
  }

  public post_(actionUrl: any, request: any): Observable<any> {
    return this.post(actionUrl, request, {headers: utility.allHeader});
  }

  // public authPost_(actionUrl: any, request: any): Observable<any> {
  //   return this.authPost(actionUrl, request, {headers: utility.allHeader});
  // }

  public downloadFile(actionUrl: any): Observable<any> {
    return this.get(actionUrl, {responseType: 'blob'});
  }

  public downloadFilePdf(url: string, filename: string) {
    this.downloadFile_(url, filename, "application/pdf");
  }

  public downloadFileExcel(url: string, filename: string) {
    this.downloadFile_(url, filename, "application/octet-stream");
  }

  public downloadFile_(url: string, filename: string, fileType: string) {
    this.downloadFile(url).subscribe(response => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob: Blob = new Blob([response], {type: fileType});
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      Utils.saveBlob(newBlob, `${filename}.pdf`);
      return;
    });
  }

  public uploadFile(actionUrl: any, request: any): Observable<any> {
    return this.post(actionUrl, request, {reportProgress: true, observe: 'events'});
  }


  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      case 400: {
        return `Bad Request Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.message}`;
      }

    }
  }

  handleError(error: HttpErrorResponse) {
    if (this.suppressAlertError) {
      return throwError(error);
    } else {
      let errorMessage = 'Unknown error!';
      if (error.error instanceof ErrorEvent) {
        // Client-side errors
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side errors
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      window.alert(errorMessage);
      return throwError(errorMessage);
    }
  }

  handleErrorWithConsole(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }

  public getWithHeader(actionUrl: any, httpHeaders: HttpHeaders): Observable<any> {
    return this.get(actionUrl, {headers: httpHeaders});
  }

  public postWithHeader(actionUrl: any, requestBody: any, httpHeaders: HttpHeaders): Observable<any> {
    return this.post(actionUrl, requestBody, {headers: httpHeaders});
  }

  public get baseURL(): string {
    return environment.baseURL;
  }

  getBnResults(searchParam:string): Observable<any> {

    return this.httpClient.get(this.BnSearchUrl + '/api/v1/public/utility/search-by-name-or-rc-number?nameOrRcNumber='+searchParam);

  }


}
